export default function PricingIncluded() {
    return (
        <section className="included-section">
            <div className="container included-grid">
                <div>
                    <span className="eyebrow">What’s included</span>
                    <h3 className="included-title">Everything you need, every month</h3>
                    <ul className="included-list">
                        <li>Hosting, SSL, backups & monitoring</li>
                        <li>Unlimited menu updates (CSV or dashboard)</li>
                        <li>Seasonal promos & banners</li>
                        <li>Speed, accessibility & basic SEO upkeep</li>
                        <li>Email support with 24–48h turnaround</li>
                    </ul>
                </div>

                <div>
                    <span className="eyebrow">Setup scope</span>
                    <h3 className="included-title">What determines the one‑time setup</h3>
                    <dl className="scope-list">
                        <div className="scope-row">
                            <dt>Content migration</dt>
                            <dd>Pages, menus, and images moved from your current site or PDFs.</dd>
                        </div>
                        <div className="scope-row">
                            <dt>Photography</dt>
                            <dd>Optional on‑site shoot for interiors, dishes, and cocktails.</dd>
                        </div>
                        <div className="scope-row">
                            <dt>Integrations</dt>
                            <dd>Resy/OpenTable, Toast/Square, Tock, email, analytics, and more.</dd>
                        </div>
                    </dl>

                    <a href="/book-call" className="btn btn-accent-primary btn-sm included-cta">
                        Book a 15‑min discovery
                    </a>
                </div>
            </div>
        </section>
    );
}
